import React, { useState } from "react";

const Sidebar = ({ mainMenuItems, menuItems }) => {
  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (item) => {
    setActiveItem(item.id);
    if (item.clickHandler) {
      item.clickHandler();
    }
  };

  return (
    <div className="sidebarmenu">
      <div className="menubtn">
        <ul>
          {mainMenuItems?.map((item) => (
            <li key={item.id} className={activeItem === item.id ? "active" : ""} onClick={() => handleItemClick(item)}>
              <div className="sidetooltip">
                <span>{item.icon}</span>
                <p className="tooltiptext">{item.tooltip}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="menubtn">
        <ul className="mainlist">
          {menuItems?.map((item) => (
            <li key={item.id} className={activeItem === item.id ? "active" : ""} onClick={() => handleItemClick(item)}>
              <div className="sidetooltip">
                <span>{item.icon}</span>
                <p className="tooltiptext">{item.tooltip}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
